'use client';

import { Controller, useFormContext } from 'react-hook-form';
import type { FormRadioInputProps, FormType } from '../../types/types';

import { FormField } from '../FormField/FormField';
import { RadioGroup } from '../../../components/ui';

export const FormRadioInput = <T extends FormType>({
	name,
	label,
	helperText,
	optionalText,
	isRequired,
	_formField,
	children,
}: FormRadioInputProps<T>) => {
	const { control, formState } = useFormContext();

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={isRequired}
			{..._formField}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<RadioGroup
						disabled={formState.isSubmitting}
						name={field.name}
						onValueChange={({ value }) => {
							field.onChange(value);
						}}
						value={field.value}
					>{children}
					</RadioGroup>
				)}
			/>
		</FormField>
	);
};